import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SpinWheelModal from '@/components/spinWheel/SpinWheelModal';
import styles from './TopStream.module.css';

/**
 * TopStream – Tab switcher (Sports / Wheel Spin)
 * Expanded: horizontal tabs with text + icons
 * Collapsed: vertical icon-only tabs (like reference mobileContainer)
 */
const TopStream = ({ isCollapsed, onItemClick }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('wheel');
  const [showSpinModal, setShowSpinModal] = useState(false);

  const handleSports = () => {
    setActiveTab('sports');
    if (onItemClick) onItemClick();
    navigate('/sports/popular');
  };

  const handleWheel = () => {
    setActiveTab('wheel');
    setShowSpinModal(true);
  };

  if (isCollapsed) {
    return (
      <>
        <div className={styles.topSection}>
          <div className={styles.collapsedTabs}>
            <button
              className={styles.collapsedTab}
              style={{
                background: activeTab === 'sports'
                  ? 'linear-gradient(180deg, #4D0B15 0%, #5C0E1A 15%, #6B1120 35%, #5A0D18 55%, #4A0A14 75%, #380710 100%)'
                  : undefined,
              }}
              onClick={handleSports}
            >
              <img src="/assets/images/football.png" alt="Sports" />
            </button>
            <button
              className={styles.collapsedTab}
              style={{
                background: activeTab === 'wheel'
                  ? 'linear-gradient(180deg, #4D0B15 0%, #5C0E1A 15%, #6B1120 35%, #5A0D18 55%, #4A0A14 75%, #380710 100%)'
                  : undefined,
              }}
              onClick={handleWheel}
            >
              <img src="/assets/images/spin-animate.gif" alt="Wheel Spin" />
            </button>
          </div>
        </div>

        <SpinWheelModal
          isOpen={showSpinModal}
          onClose={() => setShowSpinModal(false)}
        />
      </>
    );
  }

  return (
    <>
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 'sports' ? styles.tabActive : ''}`}
            style={{ borderRadius: '8px 0 0 8px' }}
            onClick={handleSports}
          >
            <img src="/assets/images/football.png" alt="" className={styles.tabIcon} />
            Sports
          </button>

          <button
            className={`${styles.tab} ${activeTab === 'wheel' ? styles.tabActive : ''}`}
            style={{ borderRadius: '0 8px 8px 0' }}
            onClick={handleWheel}
          >
            <img src="/assets/images/spin-animate.gif" alt="" className={styles.tabIcon} />
            Wheel Spin
          </button>
        </div>
      </div>

      <SpinWheelModal
        isOpen={showSpinModal}
        onClose={() => setShowSpinModal(false)}
      />
    </>
  );
};

export default TopStream;
